import React, { useEffect, useState } from "react";
import DropdownButton from "./DropdownButton";
import ActionButton from "./ActionButton";
import SingleDropdown from "./SingleDropdown";
import { conditionsOperatorObject } from "Static/constant";
import contactStoreData from "Stores/contactData";
import Utils from "Utils/utils";

const ContactSequenceFilter = props => {
  const {
    label = "",
    keyValue = "",
    activeFilter = "",
    errMsg = "",
    data = [],
    sequenceLoader = false,
    sequenceList = [],
    setActiveFilter = () => {},
    setAction = () => {},
    selectedFilterCbk = () => {},
    handleScrollEnd = () => {},
    setErrMsg = () => {},
    filterFn = () => {},
    // Opt-in chip condition builder (matches Metrics / Contact Field).
    inlineOperator = false
  } = props || {};

  let toggleDropdown = activeFilter === keyValue;

  const [activeDropdownIndex, setActiveDropdownIndex] = useState(false);
  const [showBuilder, setShowBuilder] = useState(false);

  const validateFieldNameAlreadyExist = (newFieldName = "") => {
    let count = 0;
    if (data?.length > 1) {
      data.some(element => {
        if (element?.fieldName === newFieldName) {
          count++;
        }
      });
    }
    return !count > 0;
  };

  const handleAction = (refId = "", item = "", index = "") => {
    if (refId === "fieldName") {
      if (!validateFieldNameAlreadyExist(item?.subKey)) {
        return;
      }
      errMsg && setErrMsg();
      const newFieldName = item?.subKey || "";
      const prevFieldName = data?.[index]?.fieldName || "";
      if (!prevFieldName) {
        let tempAddData = [...data];
        tempAddData[index].fieldName = newFieldName;
        tempAddData[index].sequenceId = "";
        tempAddData[index].sequenceName = "";
        setActiveDropdownIndex(false);
        setAction(keyValue, tempAddData);
        selectedFilterCbk("add", keyValue);
        return;
      }

      if (prevFieldName === newFieldName) {
        setActiveDropdownIndex(false);
        return;
      }

      let rowsToRemove = new Set([index]);
      const currentRowIsMultiple = data[index]?.isMultiple === true;

      if (currentRowIsMultiple) {
        const parentIdx = data.findIndex(
          (itm, idx) =>
            idx < index && itm?.fieldName === prevFieldName && !itm?.isMultiple
        );

        if (parentIdx !== -1) {
          rowsToRemove.add(parentIdx);
          data.forEach((itm, idx) => {
            if (
              idx !== parentIdx &&
              idx !== index &&
              itm?.fieldName === prevFieldName &&
              itm?.isMultiple
            ) {
              rowsToRemove.add(idx);
            }
          });
        } else {
          data.forEach((itm, idx) => {
            if (
              idx > index &&
              itm?.fieldName === prevFieldName &&
              itm?.isMultiple
            ) {
              rowsToRemove.add(idx);
            }
          });
        }
      } else {
        data.forEach((itm, idx) => {
          if (
            idx !== index &&
            itm?.fieldName === prevFieldName &&
            itm?.isMultiple
          ) {
            rowsToRemove.add(idx);
          }
        });
      }
      const sortedIndicesToRemove = Array.from(rowsToRemove).sort(
        (a, b) => a - b
      );
      let filtered = [...data];
      for (let i = sortedIndicesToRemove.length - 1; i >= 0; i--) {
        filtered.splice(sortedIndicesToRemove[i], 1);
      }

      let insertionIdx = index;
      for (const removeIdx of sortedIndicesToRemove) {
        if (removeIdx < index) {
          insertionIdx--;
        }
      }

      const freshItem = {
        fieldName: newFieldName,
        sequenceId: "",
        sequenceName: "",
        isMultiple: false
      };

      insertionIdx = Math.max(0, Math.min(insertionIdx, filtered.length));
      const nextData = [
        ...filtered.slice(0, insertionIdx),
        freshItem,
        ...filtered.slice(insertionIdx)
      ];
      setActiveDropdownIndex(false);
      setAction(keyValue, nextData);
      selectedFilterCbk("add", keyValue);
      return;
    }
    errMsg && setErrMsg();
    let tempData = [...data];
    tempData[index][refId] = item?.subKey || "";
    setActiveDropdownIndex(false);
    setAction(keyValue, tempData);
  };
  const validateSeqAlreadyExist = (id = "") => {
    let count = 0;
    if (data?.length > 1) {
      data.some(ele => {
        if (ele?.sequenceId === id) {
          count++;
        }
      });
    }
    return count > 0;
  };

  const handleSequenceAction = (index = "", item = {}) => {
    errMsg && setErrMsg();
    let tempData = [...data];
    if (validateSeqAlreadyExist(item?.id)) {
      return;
    }
    tempData[index]["sequenceId"] = item?.id || "";
    tempData[index]["sequenceName"] = item?.name || "";
    setActiveDropdownIndex(false);
    setAction(keyValue, tempData);
    errMsg && setErrMsg("");
  };

  const resetOrAddNewItem = (isPush = false) => {
    let newObj = {
      fieldName: "",
      sequenceId: "",
      sequenceName: "",
      isMultiple: false
    };
    if (isPush) {
      return newObj;
    }
    errMsg && setErrMsg();
    selectedFilterCbk("remove", keyValue);
    setAction(keyValue, [newObj]);
  };

  const resetOrAddNewItemV2 = ({
    isPush = false,
    isMultiple = false,
    fieldName = ""
  } = {}) => {
    let newObj = {
      fieldName: fieldName,
      sequenceId: "",
      sequenceName: "",
      isMultiple: isMultiple
    };
    if (isPush && isMultiple) {
      return newObj;
    }
    if (isPush) {
      return newObj;
    }
    errMsg && setErrMsg();
    selectedFilterCbk("remove", keyValue);
    setAction(keyValue, [newObj]);
  };

  const removeItem = index => {
    let tempData = [...data];
    const fieldNameToRemove = tempData[index]?.fieldName || "";
    if (fieldNameToRemove) {
      const indicesToRemove = new Set([index]);
      tempData.forEach((item, idx) => {
        if (
          idx !== index &&
          item?.fieldName === fieldNameToRemove &&
          item?.isMultiple
        ) {
          indicesToRemove.add(idx);
        }
      });
      const sortedIndices = Array.from(indicesToRemove).sort((a, b) => b - a);
      sortedIndices.forEach(idx => {
        tempData.splice(idx, 1);
      });
    } else {
      tempData.splice(index, 1);
    }
    let len = tempData?.length;
    if (len === 1) {
      resetOrAddNewItem();
    } else {
      tempData.filter(item => item?.fieldName)?.length < 1 &&
        selectedFilterCbk("remove", keyValue);
      setAction(keyValue, tempData);
    }
    errMsg && setErrMsg();
  };

  const removeSelectedSeqItem = index => {
    let tempData = [...data];
    const rowToDelete = tempData[index];
    const fieldName = rowToDelete?.fieldName || "";
    const isRowMultiple = rowToDelete?.isMultiple === true;
    let len = tempData?.length;
    if (len === 1) {
      resetOrAddNewItemV2();
    } else {
      if (fieldName && !isRowMultiple) {
        const firstChildIdx = tempData.findIndex(
          (itm, idx) =>
            idx !== index &&
            itm?.fieldName === fieldName &&
            itm?.isMultiple === true
        );
        if (firstChildIdx !== -1) {
          tempData[firstChildIdx].isMultiple = false;
        }
      }
      tempData.splice(index, 1);
      tempData.filter(item => item?.fieldName)?.length < 1 &&
        selectedFilterCbk("remove", keyValue);
      setAction(keyValue, tempData);
    }
    errMsg && setErrMsg();
  };

  const addMultipleSequences = (fieldName = "") => {
    errMsg && setErrMsg();
    let tempData = [...data];
    tempData.push(
      resetOrAddNewItemV2({
        isPush: true,
        isMultiple: true,
        fieldName: fieldName
      })
    );
    setAction(keyValue, tempData);
  };

  const addItem = () => {
    errMsg && setErrMsg();
    let tempData = [...data];
    tempData.push(resetOrAddNewItem(true));
    setAction(keyValue, tempData);
  };

  const resetItem = () => {
    errMsg && setErrMsg();
    data?.filter(item => item?.fieldName)?.length && resetOrAddNewItem();
  };

  const optionList = [
    {
      value: "Active in sequence",
      subKey: "ACTIVE_IN_SEQUENCE",
      key: "activeInASequence",
      method: handleAction
    },
    {
      value: "Completed in sequence",
      subKey: "COMPLETED_IN_SEQUENCE",
      key: "completedInASequence",
      method: handleAction
    },
    {
      value: "Added to sequence",
      subKey: "ADDED_TO_SEQUENCE",
      key: "addedToSequence",
      method: handleAction
    }
  ];

  const operatorList = [
    {
      value: "<span class='conditionSymbol'>&equals;</span><span class='conditionLabel'>Equals</span>",
      subKey: "EQUALS",
      key: "equalCond",
      method: handleAction
    },
    {
      value: "<span class='conditionSymbol'>&ne;</span><span class='conditionLabel'>Not equals</span>",
      subKey: "NOT_EQUALS",
      key: "notEqualCond",
      method: handleAction
    }
  ];

  const fieldnameObject = {
    ACTIVE_IN_SEQUENCE: "Active in sequence",
    COMPLETED_IN_SEQUENCE: "Completed in sequence",
    ADDED_TO_SEQUENCE: "Added to sequence"
  };

  useEffect(() => {
    if (errMsg) {
      let tempData = { ...contactStoreData.contactFilterObject };
      tempData.sequences = [
        {
          fieldName: "",
          sequenceId: "",
          sequenceName: ""
        }
      ];
      contactStoreData.setContactFilterObject(tempData);
    }
  }, [errMsg]);

  // ──────────────── Chip model (mirrors ContactMetricsFilter) ────────────────
  const SEQ_OP_SYMBOL = { EQUALS: "=", NOT_EQUALS: "≠" };
  const chipRows = (data || []).filter(
    r => r?.committed === true && r?.fieldName && r?.sequenceId
  );
  const builderIndex = (data || []).findIndex(r => r?.committed !== true);

  const chipLabel = item => {
    const f = fieldnameObject?.[item?.fieldName] || item?.fieldName || "";
    const op = SEQ_OP_SYMBOL[item?.operator] || "=";
    return `${f} ${op} ${item?.sequenceName || ""}`;
  };

  const removeSeqChip = dataIdx => {
    const rows = [...(data || [])];
    rows.splice(dataIdx, 1);
    if (!rows.some(r => r?.committed === true)) {
      selectedFilterCbk("remove", keyValue);
    }
    setAction(keyValue, rows);
    errMsg && setErrMsg();
  };

  // Field / operator picks keep the builder row uncommitted; picking a sequence
  // commits it to a chip and appends a fresh builder row.
  const setBuilderField = (index, refId, val) => {
    errMsg && setErrMsg();
    const rows = [...(data || [])];
    if (refId === "fieldName" && rows[index]?.fieldName !== val) {
      rows[index] = { ...rows[index], fieldName: val, sequenceId: "", sequenceName: "" };
    } else {
      rows[index] = { ...rows[index], [refId]: val };
    }
    setActiveDropdownIndex(false);
    setAction(keyValue, rows);
  };

  const commitSeqBuilder = (index, item) => {
    if (validateSeqAlreadyExist(item?.id)) return;
    const rows = [...(data || [])];
    const row = rows[index] || {};
    if (!row.fieldName) return;
    rows[index] = {
      ...row,
      sequenceId: item?.id || "",
      sequenceName: item?.name || "",
      committed: true
    };
    rows.push({
      fieldName: "",
      sequenceId: "",
      sequenceName: "",
      operator: "EQUALS",
      isMultiple: false,
      committed: false
    });
    selectedFilterCbk("add", keyValue);
    setAction(keyValue, rows);
    setActiveDropdownIndex(false);
    setShowBuilder(false);
    errMsg && setErrMsg("");
  };

  const inlineOptionList = optionList.map(o => ({
    ...o,
    method: (refId, item, idx) => setBuilderField(idx, "fieldName", item?.subKey)
  }));
  const inlineOperatorList = operatorList.map(o => ({
    ...o,
    method: (refId, item, idx) => setBuilderField(idx, "operator", item?.subKey)
  }));

  // One-time normalize: pre-existing complete rows (e.g. restored from local
  // storage) → committed chips + one builder row. Skip when there's nothing to
  // convert so the default empty row isn't rewritten (which would otherwise
  // register a phantom "sequences" filter in constructFilterArr).
  useEffect(() => {
    if (!inlineOperator) return;
    const rows = data || [];
    const complete = rows.filter(r => r?.fieldName && r?.sequenceId);
    if (!complete.length) return;
    const committedRows = complete.map(r => ({ ...r, committed: true }));
    const next = [
      ...committedRows,
      {
        fieldName: "",
        sequenceId: "",
        sequenceName: "",
        operator: "EQUALS",
        isMultiple: false,
        committed: false
      }
    ];
    if (JSON.stringify(next) !== JSON.stringify(rows)) setAction(keyValue, next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (inlineOperator) {
    const bItem = (data || [])[builderIndex] || {};
    const bFieldName = bItem.fieldName || "";
    const bOperator = bItem.operator || "EQUALS";
    return (
      <div className="contactDateFilter">
        <DropdownButton
          label={label}
          count={chipRows.length}
          keyValue={keyValue}
          toggleDropdown={toggleDropdown}
          callback={setActiveFilter}
        />
        {toggleDropdown && (
          <div className="dropdownSearchBox">
            <span className="horizontalBorderLine" />
            <div className="filterChipWrap">
              {chipRows.length > 0 && (
                <div className="filterChips">
                  {chipRows.map((c, i) => (
                    <span className="filterChip" key={`seqchip-${i}`}>
                      <span className="chipText">{chipLabel(c)}</span>
                      <i
                        className="material-icons chipRemove"
                        onClick={() => removeSeqChip(data.indexOf(c))}
                      >
                        close
                      </i>
                    </span>
                  ))}
                </div>
              )}
              {!showBuilder && (
                <div
                  className="addNewButton chipAddBtn"
                  onClick={() => {
                    setShowBuilder(true);
                    setActiveDropdownIndex(`fieldName-${builderIndex}`);
                  }}
                >
                  <i className="material-icons addIcon">add_circle_outline</i>
                  <span className="text">Add condition</span>
                </div>
              )}
              {showBuilder && builderIndex > -1 && (
                <div className="chipBuilder">
                  <div className="fieldnameDropdown fieldnameOperatorRow">
                    <SingleDropdown
                      isDropdownAllowed={true}
                      options={inlineOptionList}
                      defaultValue={fieldnameObject?.[bFieldName] || ""}
                      label="Select condition"
                      referenceId="fieldName"
                      parentIndex={builderIndex}
                      hasCustomFieldValue={true}
                      showDropdown={
                        activeDropdownIndex === `fieldName-${builderIndex}`
                      }
                      setActiveDropdownIndex={setActiveDropdownIndex}
                    />
                    {bFieldName && (
                      <SingleDropdown
                        isDropdownAllowed={true}
                        options={inlineOperatorList}
                        defaultValue={conditionsOperatorObject?.[bOperator] || ""}
                        showDropdown={
                          activeDropdownIndex === `operator-${builderIndex}`
                        }
                        setActiveDropdownIndex={setActiveDropdownIndex}
                        parentIndex={builderIndex}
                        referenceId="operator"
                        className="inlineOperatorLabel"
                      />
                    )}
                  </div>
                  {bFieldName && (
                    <div className="fieldOperatorValue valueOnlyRow">
                      <div className="fieldNameSequenceDropdown">
                        <SingleDropdown
                          isDropdownAllowed={true}
                          className={"selectSequenceLabel"}
                          options={sequenceList}
                          defaultValue=""
                          sequenceId=""
                          label="Select sequence"
                          referenceId="sequenceName"
                          parentIndex={builderIndex}
                          hasCustomFieldValue={true}
                          showDropdown={
                            activeDropdownIndex === `sequenceName-${builderIndex}`
                          }
                          activeDropdownIndex={activeDropdownIndex}
                          setActiveDropdownIndex={setActiveDropdownIndex}
                          handleSequenceAction={commitSeqBuilder}
                          handleScrollEnd={handleScrollEnd}
                          isCustomDropdown={true}
                          sequenceLoader={sequenceLoader}
                          animationClass="customDropDownFadeIn"
                          search={true}
                          filterFn={filterFn}
                          isPositionTop={true}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            {errMsg === keyValue && (
              <span className="errMessage">Please select a value</span>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="contactDateFilter">
      <DropdownButton
        label={label}
        count={data?.filter(item => item?.fieldName)?.length || 0}
        keyValue={keyValue}
        toggleDropdown={toggleDropdown}
        callback={setActiveFilter}
      />
      {toggleDropdown && (
        <div className="dropdownSearchBox">
          <span className="horizontalBorderLine" />
          {(data.length && (
            <div className="sequenceFilterCard">
              {data.map((item, index) => {
                const {
                  fieldName = "",
                  sequenceId = "",
                  sequenceName = "",
                  operator = "EQUALS",
                  isMultiple = false
                } = item || {};

                const isLastItem = index === data.length - 1;
                return (
                  <div
                    className="sequenceFilter"
                    key={`sequenceFilter${index}`}
                  >
                    <div className="fieldnameDropdown">
                      {!isMultiple && (
                        <>
                          <SingleDropdown
                            isDropdownAllowed={true}
                            options={optionList}
                            defaultValue={fieldnameObject?.[fieldName] || ""}
                            label="Select"
                            referenceId="fieldName"
                            parentIndex={index}
                            hasCustomFieldValue={true}
                            showDropdown={
                              activeDropdownIndex === `fieldName-${index}`
                            }
                            setActiveDropdownIndex={setActiveDropdownIndex}
                          />

                          <i
                            className="material-icons-outlined deleteIcon"
                            onClick={() => removeItem(index)}
                          >
                            delete
                          </i>
                        </>
                      )}
                    </div>
                    {fieldName && (
                      <div className="fieldOperatorValueContainer">
                        <div className="fieldOperatorValueContainerInner">
                          <div
                            className={`fieldOperatorValue ${
                              !fieldName ? "disableInput" : ""
                            }`}
                          >
                            <SingleDropdown
                              isDropdownAllowed={true}
                              defaultValue={
                                conditionsOperatorObject?.[operator] || ""
                              }
                              showDropdown={
                                activeDropdownIndex === `operator-${index}`
                              }
                              setActiveDropdownIndex={setActiveDropdownIndex}
                              parentIndex={index}
                              referenceId="operator"
                              options={operatorList}
                            />
                            <div className="fieldNameSequenceDropdown">
                              <SingleDropdown
                                isDropdownAllowed={true}
                                className={"selectSequenceLabel"}
                                options={sequenceList}
                                defaultValue={
                                  (sequenceId && sequenceName) || ""
                                }
                                sequenceId={sequenceId}
                                label="Select"
                                referenceId="sequenceName"
                                parentIndex={index}
                                hasCustomFieldValue={true}
                                showDropdown={
                                  activeDropdownIndex ===
                                  `sequenceName-${index}`
                                }
                                activeDropdownIndex={activeDropdownIndex}
                                setActiveDropdownIndex={setActiveDropdownIndex}
                                handleSequenceAction={handleSequenceAction}
                                handleScrollEnd={handleScrollEnd}
                                isCustomDropdown={true}
                                sequenceLoader={sequenceLoader}
                                animationClass="customDropDownFadeIn"
                                search={true}
                                filterFn={filterFn}
                                isPositionTop={true}
                              />
                            </div>
                          </div>
                          <div className="deleteIconContainer">
                            <i
                              className="material-icons-outlined deleteIcon"
                              onClick={() => removeSelectedSeqItem(index)}
                            >
                              delete
                            </i>
                          </div>
                        </div>
                        {isLastItem && (
                          <div className="iconContainerWrapper">
                            <div
                              className="addIconContainer"
                              onClick={() => addMultipleSequences(fieldName)}
                            >
                              <i className="material-icons-outlined addIcon">
                                add
                              </i>
                              <span>Select Sequence</span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )) ||
            ""}
          <ActionButton resetCbk={resetItem} addCbk={addItem} isReset={false} />
          {errMsg === keyValue && (
            <span className="errMessage">Please select a value</span>
          )}
        </div>
      )}
    </div>
  );
};

export default ContactSequenceFilter;
